import React, { useState, useEffect } from 'react';
  import api from '../api';
import axios from 'axios';
import '../SeoPage.css';
import { useNavigate } from 'react-router-dom';

function SeoDashboard() {
  const [keywords, setKeywords] = useState([]);
  const [backlinks, setBacklinks] = useState([]);
  const [traffic, setTraffic] = useState(null);
  const [pages, setPages] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null);
  const [sentiment, setSentiment] = useState(null);
  const [averageSeoScore, setAverageSeoScore] = useState(0);
  const [topKeyword, setTopKeyword] = useState(null);
  const navigate = useNavigate();

// Fetch keywords
useEffect(() => {
  api.get('/seo/keywords')
    .then(res => setKeywords(res.data))
    .catch(err => console.error('Error fetching keywords:', err));
}, []);

// Fetch backlinks
useEffect(() => {
  api.get('/seo/backlinks')
    .then(res => setBacklinks(res.data))
    .catch(err => console.error('Error fetching backlinks:', err));
}, []);

// Fetch traffic summary
useEffect(() => {
  api.get('/seo/traffic')
    .then(res => setTraffic(res.data))
    .catch(err => console.error('Error fetching traffic:', err));
}, []);

// Fetch pages with SEO health summary
useEffect(() => {
  api.get('/seo/pages')
    .then(res => setPages(res.data))
    .catch(err => console.error('Error fetching pages:', err));
}, []);

// Fetch AI sentiment for selected page
useEffect(() => {
  if (!selectedPage) {
    setSentiment(null);
    return;
  }
  api.get(`/seo/sentiment?pageId=${selectedPage.id}`)
    .then(res => setSentiment(res.data))
    .catch(err => console.error('Error fetching sentiment:', err));
}, [selectedPage]);


  // Calculate average SEO score and top keyword
  useEffect(() => {
    if (pages.length) {
      const avg = pages.reduce((sum, p) => sum + p.seoScore, 0) / pages.length;
      setAverageSeoScore(avg.toFixed(1));
    }

    if (keywords.length) {
      const sorted = [...keywords].sort((a, b) => b.volume - a.volume);
      setTopKeyword(sorted[0]);
    }
  }, [pages, keywords]);

  return (
    <div className="App">
      <h1>SEO Dashboard</h1>

      {/* Impact Score Overview */}
      <div className="impact-score-panel">
        <h2>Impact Overview</h2>
        <div className="impact-cards">
          <div className="impact-card">
            <h3>Organic Traffic</h3>
            <p>{traffic?.organicVisits ?? 'Loading...'}</p>
          </div>
          <div className="impact-card">
            <h3>Avg SEO Score</h3>
            <p>{averageSeoScore}%</p>
          </div>
          <div className="impact-card">
            <h3>Top Keyword</h3>
            <p>{topKeyword?.keyword ?? 'N/A'}</p>
          </div>
          <div className="impact-card">
            <h3>AI Sentiment</h3>
            <p>{sentiment?.score ?? 'Select a page'}</p>
          </div>
        </div>

        {/* Graph Placeholder */}
        <div className="impact-graph-placeholder">
          <p>[Graph coming soon]</p>
        </div>
      </div>

      <div className="app-container">

        {/* Left Panel: Keywords */}
        <div className="seo-keywords-container">
          <h2>Top Keywords</h2>
          {keywords.length === 0 && <p>Loading keywords...</p>}
          <ul>
            {keywords.map(k => (
              <li key={k.id}>
                <strong>{k.keyword}</strong> - Volume: {k.volume} - CPC: ${k.cpc}
              </li>
            ))}
          </ul>
        </div>

        {/* Center Panel: Pages & SEO Health */}
        <div className="seo-pages-container">
          <h2>Pages SEO Health</h2>
          {pages.length === 0 && <p>Loading pages...</p>}
          <ul>
            {pages.map(page => (
              <li 
                key={page.id} 
                style={{ cursor: 'pointer', fontWeight: selectedPage?.id === page.id ? 'bold' : 'normal' }}
                onClick={() => setSelectedPage(page)}
              >
                {page.url} - Score: {page.seoScore}%
              </li>
            ))}
          </ul>

          {/* AI Sentiment for selected page */}
          {selectedPage && sentiment && (
            <div className="sentiment-panel">
              <h3>AI Sentiment for {selectedPage.url}</h3>
              <p>Sentiment Score: {sentiment.score}</p>
              <p>Summary: {sentiment.summary}</p>
            </div>
          )}
        </div>

        {/* Right Panel: Backlinks & Traffic */}
        <div className="seo-backlinks-container">
          <h2>Backlinks Overview</h2>
          {backlinks.length === 0 && <p>Loading backlinks...</p>}
          <ul>
            {backlinks.map(link => (
              <li key={link.id}>
                <a href={link.sourceUrl} target="_blank" rel="noopener noreferrer">{link.sourceDomain}</a> → {link.targetUrl}
              </li>
            ))}
          </ul>
        </div>

        <div className="seo-backlinks-container">
          <h2>Traffic Summary</h2>
          {traffic ? (
            <div>
              <p>Organic Visits: {traffic.organicVisits}</p>
              <p>Bounce Rate: {traffic.bounceRate}%</p>
              <p>Avg. Session Duration: {traffic.avgSessionDuration} mins</p>
            </div>
          ) : (
            <p>Loading traffic data...</p>
          )}
        </div>

      </div>

      {/* Action Buttons */}
      <div className="impact-buttons">
        <button onClick={() => navigate('/content')}>Content Brief</button>
        <button onClick={() => navigate('/design')}>Design Brief</button>
      </div>
    </div>
  );
}

export default SeoDashboard;
